import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';

import { NavigationService } from './navigation.service';
import { NavigationLoaderService } from './navigation-loader.service';

export function provideNavigation(): (Provider | EnvironmentProviders)[] {
  return [
    provideEnvironmentInitializer(() => inject(NavigationService)),
    provideEnvironmentInitializer(() => inject(NavigationLoaderService)),
  ];
}
